export default __webpack_public_path__ + "static/img_interviewee_jelee@2x-364abe9225140e595556fa74b599bcbf.png";